export default {
  INVALID_TRACKING_NUMBER: 3003,
  TRACKING_NOT_FOUND: 3220
};
